import { render, staticRenderFns } from "./editKPIChart.vue?vue&type=template&id=b4d17a6c&"
import script from "./editKPIChart.vue?vue&type=script&lang=js&"
export * from "./editKPIChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports